import FuseNavigation from '@fuse/core/FuseNavigation';
import clsx from 'clsx';
import { memo, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectNavigation } from 'app/store/fuse/navigationSlice';
import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import { navbarCloseMobile } from 'app/store/fuse/navbarSlice';
import { logoutUser, selectUser } from 'app/store/userSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Navigation(props) {
  const { t } = useTranslation('translate-language');
  const user = useSelector(selectUser);
  const navigation = useSelector(selectNavigation);
  const location = useLocation()
  const lab = [
    {
      "id": 101,
      "title": t("Labaratory"),
      "translate": "Labaratory",
      "type": "item",
      "icon": "material-outline:settings_suggest",
      "url": "laboratory"
    },
    {
      "id": 102,
      "title": t("Repair"),
      "translate": "Repair",
      "type": "item",
      "icon": "material-outline:settings_suggest",
      "url": "repair"
    }
  ];

  const navigate = useNavigate()
  
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));
  const permissionsMap = user?.permissions 
  ? Object.fromEntries(user.permissions.map(permission => [permission.permission_id, permission.has_permission]))
  : {};  const updatedPermissionsMap = (user.branch_id == 1)
    ? { ...permissionsMap, 11: true,12:true }
    : permissionsMap;

    useEffect(() => {
      if (!user?.permissions) {
        //  dispatch(logoutUser());
        navigate('/');
      }
    }, [user, navigation, navigate]);

  let filteredNavigationConfig = (user.branch_id == -1 || user.branch_id == 1) ? navigation.filter(item => updatedPermissionsMap[item.id]).concat(lab) : navigation.filter(item => updatedPermissionsMap[item.id]);

   if (user.role == "SUPER_ADMIN") {
    const targetObject = filteredNavigationConfig.find(item => item.id === 4);
    if (targetObject && targetObject.children) {
      const isAccessExists = targetObject.children.some(child => child.id === 'access');

      if (!isAccessExists) {
        targetObject.children.push({
          id: 'access',
          title: t('Access'),
          type: 'item',
          url: 'staff/permissions',
          translate: t('Access'),
          end: true,
        });
      }
    }

    filteredNavigationConfig = filteredNavigationConfig.map(item =>
      item.id === 4 ? targetObject : item
    );
  }

  function findItemWithUrl(items, url) {

    for (const item of items) {
      if (item.url === url || (!isNaN(location.pathname.split("/").filter(Boolean).pop()) && url.split("/").filter(Boolean)[0] === item?.url?.split("/").filter(Boolean)[0])) {
        return true;
      }
      if (item.children && item.children.length > 0) {
        const foundInChildren = findItemWithUrl(item.children, url);
        if (foundInChildren) {
          return true;
        }
      }
    }
    return false;
  }
  useEffect(() => {
    let found = findItemWithUrl(filteredNavigationConfig, location.pathname.slice(1));
    if (location.pathname === "/profile") {
      found = true;
    }
    if (!found) {
      navigate('/');
    }
  }, [location]);



  const dispatch = useDispatch();

  return useMemo(() => {
    function handleItemClick(item) {
      if (isMobile) {
        dispatch(navbarCloseMobile());
      }
    }



    return (
      <FuseNavigation
        className={clsx('navigation', props.className)}
        navigation={filteredNavigationConfig}
        layout={props.layout}
        dense={props.dense}
        active={props.active}
        onItemClick={handleItemClick}
      />
    );
  }, [dispatch, isMobile, navigation, props.active, props.className, props.dense, props.layout]);
}

Navigation.defaultProps = {
  layout: 'vertical',
};

export default memo(Navigation);
